import {put, takeLatest, call} from 'redux-saga/effects';
import * as paymentService from "../../../services/paymentService";
import {
    LIST_CARDS,
    LIST_CARDS_SUCCESS,
    LIST_CARDS_ERROR,
}
    from "../../actions/payment"

function* listCardsSaga(action) {
    try {
       const data  = yield call(paymentService.ListCards,action.payload)
       yield put({
        type: LIST_CARDS_SUCCESS,
        payload: data
    })


    } catch (error) {
        yield put({
            type: LIST_CARDS_ERROR,error: error.data
        })
    }
}


export function* listCardsSagaWatcher() {
    yield takeLatest(LIST_CARDS, listCardsSaga)
}